import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhoneMedical = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.63079 15.9475L8.05246 17.3692C9.34222 18.6598 10.7693 19.8056 12.3083 20.7858L12.3166 20.7908C13.0366 21.2494 13.8914 21.4486 14.7399 21.3556C15.5884 21.2626 16.3798 20.8828 16.9833 20.2792L17.5075 19.7542C17.7418 19.5197 17.8734 19.2019 17.8734 18.8704C17.8734 18.539 17.7418 18.2211 17.5075 17.9867L15.2983 15.7767C15.1822 15.6605 15.0444 15.5684 14.8927 15.5055C14.741 15.4426 14.5783 15.4103 14.4141 15.4103C14.2499 15.4103 14.0873 15.4426 13.9356 15.5055C13.7839 15.5684 13.646 15.6605 13.53 15.7767C13.2955 16.011 12.9777 16.1426 12.6462 16.1426C12.3147 16.1426 11.9969 16.011 11.7625 15.7767L8.22579 12.2392C7.99145 12.0047 7.85981 11.6869 7.85981 11.3554C7.85981 11.024 7.99145 10.7061 8.22579 10.4717V10.4717C8.34195 10.3556 8.43409 10.2177 8.49696 10.066C8.55983 9.91432 8.59219 9.75171 8.59219 9.58749C8.59219 9.42327 8.55983 9.26066 8.49696 9.10895C8.43409 8.95724 8.34195 8.81941 8.22579 8.70332L6.01579 6.49416C5.78138 6.25982 5.46349 6.12817 5.13204 6.12817C4.80058 6.12817 4.4827 6.25982 4.24829 6.49416L3.72329 7.01832C3.11961 7.62181 2.73989 8.41318 2.64686 9.26168C2.55382 10.1102 2.75305 10.965 3.21162 11.685L3.21662 11.6933C4.19621 13.2316 5.34107 14.6581 6.63079 15.9475Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 5.75C21.375 5.58424 21.3092 5.42527 21.1919 5.30806C21.0747 5.19085 20.9158 5.125 20.75 5.125H18.875V3.25C18.875 3.08424 18.8092 2.92527 18.6919 2.80806C18.5747 2.69085 18.4158 2.625 18.25 2.625H15.75C15.5842 2.625 15.4253 2.69085 15.3081 2.80806C15.1908 2.92527 15.125 3.08424 15.125 3.25V5.125H13.25C13.0842 5.125 12.9253 5.19085 12.8081 5.30806C12.6908 5.42527 12.625 5.58424 12.625 5.75V8.25C12.625 8.41576 12.6908 8.57473 12.8081 8.69194C12.9253 8.80915 13.0842 8.875 13.25 8.875H15.125V10.75C15.125 10.9158 15.1908 11.0747 15.3081 11.1919C15.4253 11.3092 15.5842 11.375 15.75 11.375H18.25C18.4158 11.375 18.5747 11.3092 18.6919 11.1919C18.8092 11.0747 18.875 10.9158 18.875 10.75V8.875H20.75C20.9158 8.875 21.0747 8.80915 21.1919 8.69194C21.3092 8.57473 21.375 8.41576 21.375 8.25V5.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhoneMedical.displayName = 'SvgPhoneMedical';
export default SvgPhoneMedical;
